import { all, call } from 'redux-saga/effects'

import feedbacksSaga from './sagas/feedbacks'

function* rootSaga() {
  yield all([
    call(feedbacksSaga),
  ])
}

export default rootSaga
